export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7707.a26d385a.jpg";